export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/traveler-center.1dc699eb-642ba7.svg";